import styled from 'styled-components';

export const GameTitleDefaultBox = styled.div`
    line-height: 2.5rem;
    font-size: 1.5em;
    font-weight: 300;
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.colors.bodyText};

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        max-width: 13rem;
        line-height: 1.7;
    }
`;
